module.exports = __webpack_public_path__ + "static/media/lafise-heart-percent.1063542f.svg";